import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'

import {withRouter} from "react-router-dom";
import {message, Modal} from "antd";
import 'react-multi-select-panel/index.css'
import {normaluserlist, userdeleteapi} from "../../../../servers/goodsManageApi";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.addHandler = this.addHandler.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.onTableChange = this.onTableChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    dataSourceall: [],
    page: tableData.tPage,
    loading: false
  };

  onTableChange(data){
    let d =this.state.dataSourceall
    var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
    var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
    var newDataList = [];
    for(var i = bIndex;i < eIndex;i++){
      if (d[i]) {
        newDataList.push(d[i]);
      }
    }
    this.setState({
      page: {...this.state.page, ...data.data},
      dataSource:newDataList
    })
  }


  // 获取用户列表数据
  getListData(){
    let getData = {
      id: ''
    };
    this.setState({
      loading: true
    });
    normaluserlist(getData).then(res=>{
      let d = JSON.parse(JSON.stringify(res.records[0].datalist))
      let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)
      this.setState({
        dataSource: data,
        dataSourceall:res.records[0].datalist,
        page: {...this.state.page, total:res.records[0].datalist.length},
        loading: false,
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  /*新增*/
  addHandler(){
    this.props.history.push({
      pathname: '/adduser',
      search: '?type=new'
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('userEdit', JSON.stringify(data))
    this.props.history.push({
      pathname: '/adduser',
      search: `?type=edit&id=${data.id}`
    })
  }

  onDelete(data){
    Modal.confirm({
      content: '确认删除该用户',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        const params = {
          id:data
        }
        userdeleteapi(params).then(res=>{
          if (res.statecode === 0) {
            message.success('删除成功');
            this.getListData()
          } else {
            message.error('删除失败');
          }
        })
      }
    });
  }

  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <CButton type='primary' authId='goodsManageListNewAdd' onClick={this.addHandler}>新增</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource}
                  page={this.state.page}
                  onTableChange={this.onTableChange}
          >
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>编辑</CButton>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.onDelete(record.id)} style={{marginLeft:'20px'}}>删除</CButton>
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
